import React from 'react'
import { Box, Button } from '@mui/material';
import { FieldArray, Form, Formik } from "formik";
import { useSnackbar } from 'notistack';
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ProjectTechMultiFileForm from '../../../components/techmng/techfiles/ProjectTechMultiFileForm';
import { listProjectTechFiles } from '../../../modules/techModule/projectTechFiles';
import * as fileApi from '../../../lib/api/file';
import * as chanceApi from '../../../lib/api/chance';
import { setProject } from '../../../modules/techModule/project';

const validationSchema = yup.object().shape({
    files: yup.array().of(
        yup.object().shape({
            fileAttrVal2: yup.string().required('파일 타입을 선택하세요'),
            fileDesc: yup.string().nullable('비고를 입력하세요'),
            file: yup.mixed().required('파일을 선택하세요'),
        })
    )
});



const ProjectTechMultiFileFormContainer = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { project } = useSelector(({ techModule }) => ({
        project: techModule.project.project,
    }));

    const reloadProject = async (id) => {
        const response = await chanceApi.getChance(id);
        if (response.data.info) {
            dispatch(setProject(response.data.info));
            navigate(`/techmng/${id}/${response.data.info.techGrade}/4`)
        }
    }

    const onSave = async (value) => {
        let formData = new FormData();
        formData.append('fileDt', value.file);
        formData.append('fileTyp', 'tech_file');
        formData.append('fileAttrVal1', project.prjUuid);
        formData.append('fileAttrVal2', value.fileAttrVal2);
        formData.append('fileDesc', value.fileDesc);
        //console.log(formData, 'formData');

        try {
            // const response = await fileApi.addFiles(formData);
            const response = await fileApi.addTechFiles(formData);
            if (response.data) {
                dispatch(listProjectTechFiles('tech_file', project.prjUuid));
                //dispatch(viewProject(project.prjUuid))
                //navigation
                reloadProject(project.prjUuid);
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }
    };


    return (
        <Box sx={{ my: 1 }}>


            <Formik
                initialValues={{
                    files: [{
                        fileAttrVal2: '',
                        fileDesc: '',
                        file: null
                    }]
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm }) => {
                    // console.log("onSubmit", JSON.stringify(values, null, 2));
                    if (values.files.length > 0) {

                        values.files.forEach(value => {
                            onSave(value)
                        })
                        resetForm();
                    }


                }}
            >
                {({ isSubmitting, values, touched, errors, handleChange, handleBlur, isValid, arrayHelpers }) => (
                    <Form noValidate autoComplete="off">
                        <FieldArray name="files"
                            render={arrayHelpers => (
                                <Box>
                                    <Box>
                                        {values.files.map((f, index) => {


                                            return (
                                                <ProjectTechMultiFileForm
                                                    key={index}
                                                    file={f}
                                                    index={index}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    handleRemove={() => arrayHelpers.remove(index)} />
                                            )
                                        })}
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 2 }}>
                                        <Button sx={{ mx: 2 }} color="secondary" variant="outlined" onClick={() => arrayHelpers.push({ fileAttrVal2: '', fileDesc: '', file: null })}>파일 추가</Button>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            variant="contained"
                                            disabled={!isValid || values.files.length === 0 || isSubmitting}
                                        >
                                            저장
                                        </Button>
                                    </Box>
                                </Box>

                            )}

                        >

                        </FieldArray>
                    </Form>
                )}
            </Formik>

        </Box>
    )
}

export default ProjectTechMultiFileFormContainer